import { render } from "./SheetTitle.vue?vue&type=template&id=16a7827f&ts=true"
import script from "./SheetTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetTitle.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16a7827f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16a7827f', __exports__)) {
    api.reload('16a7827f', __exports__)
  }
  
  module.hot.accept("./SheetTitle.vue?vue&type=template&id=16a7827f&ts=true", () => {
    api.rerender('16a7827f', render)
  })

}


export default __exports__